document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-mc-tabs]');
  if (!root) return;

  const tabs = root.querySelectorAll('[data-mc-tab]');
const panels = document.querySelectorAll('.shopify-section.mc-tab-panel');

  const activate = (name) => {
    tabs.forEach((btn) => {
      const isActive = btn.getAttribute('data-mc-tab') === name;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach((panel) => {
      const isPanel = panel.classList.contains(`mc-tab-panel--${name}`);
      panel.classList.toggle('is-active', isPanel);
    });
  };

  tabs.forEach((btn) => {
    btn.addEventListener('click', () => {
      activate(btn.getAttribute('data-mc-tab'));
    });
  });

  // état initial
  const initial = root.querySelector('.mc-tab.is-active')?.getAttribute('data-mc-tab') || 'histoire';
  activate(initial);
});
